import React from 'react';
import { Link } from 'react-router-dom';
import AssistirMaisTardeTable from '../common/tables/assistir-mais-tarde-table';

const AssistirMaisTardeArea = () => {
  return (
    <>
      <section className="blog__area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12">
              <div className="blog__wrapper">
                <div className="blog__text mb-40">
                 
                <h2 className="section__title">Assistir mais tarde</h2>

                  {/* table */}
                  
                  <AssistirMaisTardeTable />

                  {/* table */}
                </div>
              </div>
            </div>
          </div>
        </div>
        </section>
       
    </>
  );
};

export default AssistirMaisTardeArea;